import { Box, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LifestylePackageCard } from "./LifestylePackageCard";
import { PlusPackageCard } from "./PlusPackageCard";
import { PremiumPackageCard } from "./PremiumPackageCard";

export const PricingCardsSection = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        py: 8,
        backgroundColor: "primary.100",
      }}
    >
      <Container
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          columnGap: 2,
        }}
      >
        <Box sx={{ gridColumn: "2 / span 10" }}>
          <Typography variant="h3" color="text.black" textAlign="center">
            {t("product-package.subtitle")}
          </Typography>
          <Typography
            color="text.black"
            sx={{
              typography: {
                xs: "h3",
                md: "h2",
              },
            }}
            textAlign="center"
          >
            {t("product-package.title")}
          </Typography>
          <Stack
            direction={{ xs: "column", lg: "row" }}
            spacing={{ xs: 2, lg: 4 }}
            alignItems={{ xs: "center", lg: "stretch" }}
            mt={{ xs: 3, md: 5, lg: 7 }}
          >
            <LifestylePackageCard />
            <PlusPackageCard />
            <PremiumPackageCard />
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};
